module.exports = __webpack_public_path__ + "static/media/happy.8dd311f9.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/happy.png
// module id = 1722
// module chunks = 0